import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-supervisor-single-visit-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './single-visit-tab.component.html',
  providers: [{ provide: TabComponent, useExisting: SupervisorSingleVisitTabComponent }],
})
export class SupervisorSingleVisitTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Single Visit');

  userId = input.required<string>();
  endpoint = computed(() => `/visits/tables/supervisors-single-visits/${this.userId()}`);

  public async main(): Promise<void> {}
}
